export abstract class CountryUtils {
  static async getCountries(): Promise<{ shortName: string; fullName: string }[] | undefined> {
    const response = await fetch(`/api/cms/countries`);
    if (response.ok) {
      return response.json();
    }
    return undefined;
  }
}
